import { PropsWithChildren } from "react";

import { Dialog, IDialogProps } from "@bps/fluent-ui";

export interface CommandDialogProps
  extends Pick<IDialogProps, "onDismiss" | "hidden"> {
  modeLabel: "Edit" | "Add";
}

export const CommandDialog: React.FC<PropsWithChildren<CommandDialogProps>> = ({
  modeLabel,
  children,
  ...props
}) => {
  return (
    <Dialog
      dialogContentProps={{
        showCloseButton: true,
        title: `${modeLabel} Command`
      }}
      minWidth="50%"
      maxWidth="50%"
      {...props}
    >
      {children}
    </Dialog>
  );
};
